import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Capacity = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Capacity' {...props}>
    <path fill='none' stroke='#000' strokeLinecap='round' strokeWidth='2' d='M1,19 L23,19 L23,5 L1,5 L1,19 Z M4,16 L7,16 L7,8 L4,8 L4,16 Z M10,16 L13,16 L13,8 L10,8 L10,16 Z' />
  </StyledIcon>
);
